import { clientesDB } from './index'

export async function obtenerClientes() {
  const result = await clientesDB.allDocs({ include_docs: true })
  return result.rows.map(r => r.doc).filter(d => !d._id.startsWith('_design'))
}

export async function buscarClientes(termino) {
  const todos = await obtenerClientes()
  if (!termino) return todos
  const t = termino.toLowerCase()
  return todos.filter(c =>
    c.nombre.toLowerCase().includes(t) ||
    (c.telefono && c.telefono.includes(t))
  )
}

export async function obtenerCliente(id) {
  return await clientesDB.get(id)
}

export async function guardarCliente(cliente) {
  if (cliente._id) {
    return await clientesDB.put(cliente)
  }
  const id = `cliente_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`
  return await clientesDB.put({
    _id: id,
    deuda: 0,
    ...cliente,
    creadoEn: new Date().toISOString(),
  })
}

export async function eliminarCliente(cliente) {
  return await clientesDB.remove(cliente)
}

// delta positivo = aumenta deuda (fiado), delta negativo = abono
export async function actualizarDeuda(clienteId, delta) {
  const cliente = await obtenerCliente(clienteId)
  cliente.deuda = Math.max(0, (cliente.deuda || 0) + delta)
  return await clientesDB.put(cliente)
}
